import "./not-found.css";
import { Row, Col, Typography, Button, Space } from "antd";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;

const NotFound = () => {
  let navigate = useNavigate();

  const returnHome = async () => {
    navigate("/");
  };

  return (
    <>
      <Row
        justify="space-around"
        align="middle"
        style={{
          height: "100vh",
        }}
      >
        <Col>
          <div className="nofoundcard">
            <Space
              direction="vertical"
              style={{
                position: "absolute",
                bottom: "15%",
                left: "13%",
                right: "13%",
              }}
            >
              <Title level={5}>We Could Not Find The Page You're Looking For</Title>
              <div
                style={{
                  textAlign: "left",
                }}
              >
                <Text>The link you're trying to access is probably broken, or the page has been removed.</Text>
              </div>
              {/* <Text type="danger">User doesn't exist in SSO please contact administrator</Text> */}
              {/* {APP_ID &&  */}
              <div className="text-center">
                <Button
                  onClick={() => {
                    returnHome();
                  }}
                  style={{
                    width: "50%",
                    backgroundColor: "#63CABD",
                    color: "white",
                    marginTop: "10px",
                  }}
                >
                  Return Home
                </Button>
              </div>
              {/* } */}
            </Space>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default NotFound;
